<template>
    <div class="payable-receivable-filter-bar">
        <ButtonToggle titleActive="Todas" titleInactive="Todas" colorActive="var(--color-brand)"
            classIconActive="fa-regular fa-check-double" classIconInactive="fa-sharp fa-solid fa-list-check"
            colorInactive="var(--bg-hover)" :disabled="filterToday" :value="filterAll ? 1 : 0" @input="onAllChange(!!$event)" />
        <ButtonToggle titleActive="Hoje" titleInactive="Hoje" colorActive="var(--color-warning)"
            classIconActive="fa-regular fa-check-double" classIconInactive="fa-solid fa-calendar-week"
            colorInactive="var(--bg-hover)" :disabled="filterAll" :value="filterToday ? 1 : 0"
            @input="onTodayChange(!!$event)" />
        <DateMonthYearPicker :year="localFilterState.year" :month="localFilterState.month" :mode="localFilterState.mode"
            :startDate="localFilterState.startDate" :endDate="localFilterState.endDate"
            :stringFilter="localFilterState.filterQueryModel" :disabled="isPickerDisabled" @change="onPickerChange" />
    </div>
</template>

<script>
import ButtonToggle from "@/ui/forms/ButtonToggle";
import DateMonthYearPicker, {
    applyDueDateMetaToStringFilter,
    buildDueDateMetaForAll,
    buildDueDateMetaForToday,
    buildDueDateMetaFromMonth,
} from "@/ui/forms/DateMonthYearPicker.vue";
import {
    createPayableReceivableDefaultFilterState,
    payableReceivableDueDateOrderField,
    payableReceivableDueDateTitle,
} from "../../services/payableReceivableList.config";

export default {
    name: "PayableReceivableFilterBar",
    components: { ButtonToggle, DateMonthYearPicker },
    props: {
        filterState: {
            type: Object,
            default: () => createPayableReceivableDefaultFilterState(),
        },
    },
    data() {
        return {
            localFilterState: createPayableReceivableDefaultFilterState(),
        };
    },
    watch: {
        filterState: {
            handler(value) {
                this.localFilterState = {
                    ...createPayableReceivableDefaultFilterState(),
                    ...value,
                };
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        filterAll() {
            return this.localFilterState.scope === "all";
        },
        filterToday() {
            return this.localFilterState.scope === "today";
        },
        isPickerDisabled() {
            return this.filterAll || this.filterToday;
        },
    },
    methods: {
        buildStringFilterWithDueDate(dueDateMeta) {
            return applyDueDateMetaToStringFilter({
                stringFilter: this.localFilterState.filterQueryModel,
                dueDateMeta,
                routeName: this.$route.name,
                field: payableReceivableDueDateOrderField,
                title: payableReceivableDueDateTitle,
                type: "date",
            });
        },
        ensureMonthDefaultFilterState() {
            const now = new Date();
            const year = this.localFilterState.year || now.getFullYear();
            const month = this.localFilterState.month || now.getMonth() + 1;
            const dueDateMeta = buildDueDateMetaFromMonth(year, month);
            this.localFilterState = {
                ...this.localFilterState,
                scope: "picker",
                mode: "month",
                year,
                month,
                startDate: "",
                endDate: "",
                filterQueryModel: this.buildStringFilterWithDueDate(dueDateMeta),
            };
            this.$emit("change", this.localFilterState);
        },
        emitChange(nextState, stringFilter) {
            const mergedFilterState = {
                ...this.localFilterState,
                ...nextState,
            };
            this.localFilterState = {
                ...mergedFilterState,
                filterQueryModel: Array.isArray(stringFilter)
                    ? stringFilter
                    : (Array.isArray(this.localFilterState.filterQueryModel) ? this.localFilterState.filterQueryModel : []),
            };
            this.$emit("change", this.localFilterState);
        },
        restoreMonthFilter() {
            const now = new Date();
            const year = this.localFilterState.year || now.getFullYear();
            const month = this.localFilterState.month || now.getMonth() + 1;
            const dueDateMeta = buildDueDateMetaFromMonth(year, month);
            this.emitChange({
                scope: "picker",
                mode: "month",
                year,
                month,
                startDate: "",
                endDate: "",
            }, this.buildStringFilterWithDueDate(dueDateMeta));
        },
        onAllChange(active) {
            if (active) {
                this.emitChange({ scope: "all" }, this.buildStringFilterWithDueDate(buildDueDateMetaForAll()));
                return;
            }
            this.restoreMonthFilter();
        },
        onTodayChange(active) {
            if (active) {
                this.emitChange({ scope: "today" }, this.buildStringFilterWithDueDate(buildDueDateMetaForToday()));
                return;
            }
            this.restoreMonthFilter();
        },
        onPickerChange(payload) {
            if (payload.mode === "month") {
                this.emitChange({
                    scope: "picker",
                    mode: "month",
                    year: payload.year,
                    month: payload.month,
                    startDate: "",
                    endDate: "",
                }, payload.stringFilter);
                return;
            }
            this.emitChange({
                scope: "picker",
                mode: "period",
                startDate: payload.startDate,
                endDate: payload.endDate,
            }, payload.stringFilter);
        },
    },
    mounted() {
        if (!Array.isArray(this.localFilterState.filterQueryModel) || !this.localFilterState.filterQueryModel.length) {
            this.ensureMonthDefaultFilterState();
        }
    },
};
</script>

<style scoped>
.payable-receivable-filter-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
}
</style>
